import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '../ui-kit';
import { IconCircleHalfStroke, IconMoon, IconSun } from '../ui-kit/icons';
import { redirectWithParamReplacement } from '../../utils/redirect';

const ThemeSwitcher = ({ theme }) => {
  const handleChange = theme => redirectWithParamReplacement('bootstrap_theme', theme);

  const options = [
    { value: 'light', icon: <IconSun /> },
    { value: 'dark', icon: <IconMoon /> },
    { value: 'auto', icon: <IconCircleHalfStroke /> }
  ];

  return (
    <ToggleButtonGroup name="theme" type="radio" value={theme} onChange={handleChange}>
      {options.map(o => (
        <ToggleButton key={o.value} id={`${o.value}-button`} value={o.value} variant="secondary">
          {o.icon} {I18n.t(`users.themes.${o.value}`)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default ThemeSwitcher;
